import NotificationService from "@/services/NotificationService";

/**
 * @ ESTADOS : Estados del Store (valor que tienen)
 */

const state = {
  v_notificationList: [],
  v_notificationBadge: 0,
  v_timer: null,
  v_timerInterval: 60 * 1000  
}


/**
 * @ Mutaciones : Las mutaciones modifican los estados
 */
const mutations = {
  SET_NOTIFICATION_LIST: (state, data) => {
    state.v_notificationList = data
  },
  
  SET_NOTIFICATION_BADGE: (state, data) => {
    state.v_notificationBadge = data
  },
}

/**
 * @ Acciones : Ejecutan acciones 
 */
const actions = {

  /* FUNCIONES DEL SERVICIO PARA OBTENER Y EDITAR DATOS */
  /**************************************************** */
  v_getLastNotificationList({ commit, state, dispatch }) {
    return new Promise(async (resolve, reject) => {
        if(localStorage.getItem("jwt") != null) {
            //Solicitamos las ubicaciones disponibles
            let response = await NotificationService.getLastNotificationList();
            // Cambiamos los datos en VUEX
            if(response.data){
              commit('SET_NOTIFICATION_LIST', response.data)
              const numBadges = response.data.filter(item => (item.status == true || item.estado == 'Activa' ));
              commit('SET_NOTIFICATION_BADGE', numBadges.length)
            }
          }
          
          // Finalizamos la ejecucion de la promise
          resolve(true)
    })
  },

  v_initNotificationCron({ commit, state, dispatch }) {
    state.v_timer = setInterval(async () => {
      dispatch('v_getLastNotificationList')
    }, state.v_timerInterval);
  },

  v_stopNotificationCron({ commit, state, dispatch }) {
    clearInterval(state.v_timer)
  }  

}



/**
 * @ Variables públicas
 */
export default {
  namespaced: true,
  state,
  mutations,
  actions
}